import React, { useEffect, useState } from 'react';
import { CircularProgress, Container, Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { getBusinessAPI } from '../../actions/business';
import TopNav from './TopNav';
import SideNav from './SideNav';
import BottomNav from './BottomNav';
import PropTypes from 'prop-types';
import {
  DashboardOutlined as DashboardIcon,
  SettingsOutlined as SettingsIcon
} from '@material-ui/icons';
import Children from './Children';


export const navItems = [
  ['Home', '', <DashboardIcon />],
  ['Settings', '/settings', <SettingsIcon />]
];


function Dashboard(props) {
  const { businessId } = props.match.params;
  const [width, setWidth] = useState(window.innerWidth);
  const business = useSelector(state => 
    state.businesses.list.find(x => x.id === businessId || x.url === businessId));

  const updateWidth = () => {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  });

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getBusinessAPI(businessId));
  }, [dispatch, businessId]);

  if (!business) return <CircularProgress />;

  return (
    <Container maxWidth='lg'>
      <TopNav business={business} />

      <Grid container spacing={2}>
        {/* Side Nav (width > 600px) */}
        {width > 600 &&
          <Grid item xs={3} md={2}>
            <SideNav business={business} />
          </Grid>}

        {/* Body */}
        <Grid
          item
          xs={width > 600 ? 9 : 12}
          md={width > 600 ? 10 : null}
        >
          <Children business={business} />
        </Grid>

        {/* Bottom Nav (width <= 600px) */}
        {width <= 600 &&
          <BottomNav business={business} />}
      </Grid>
    </Container>
  );
}


Dashboard.propTypes = {
  businessId: PropTypes.string
}


export default Dashboard;
